import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import {
  FaWhatsapp,
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaEnvelope,
  FaPhoneAlt,
  FaPlay,
  FaPause,
  FaChartLine,
  FaBolt,
  FaBrain,
  FaCogs,
  FaDatabase,
  FaLightbulb,
  FaRocket,
  FaShieldAlt,
  FaClock,
  FaCheckCircle,
  FaArrowRight,
  FaQuoteLeft,
  FaStar,
  FaSolarPanel,
  FaChartBar,
  FaNetworkWired,
  FaRobot,
} from "react-icons/fa";

// ======= SERVICIOS =======
const servicios = [
  {
    id: 1,
    icono: <FaDatabase />,
    titulo: "Plataformas de información energética",
    descripcion:
      "QuarkIA diseña y desarrolla plataformas digitales que integran, analizan y visualizan información clave del sector energético para facilitar decisiones ágiles.",
    color: "from-[#00b3b3] to-[#00e68a]",
  },
  {
    id: 2,
    icono: <FaChartLine />,
    titulo: "Proyecciones de variables energéticas",
    descripcion:
      "Modelos predictivos e inteligencia artificial que respaldan la planificación, la gestión de riesgos y la toma de decisiones estratégicas.",
    color: "from-purple-500 to-pink-500",
  },
  {
    id: 3,
    icono: <FaLightbulb />,
    titulo: "Modelos de negocio basados en datos",
    descripcion:
      "Transformación de datos en oportunidades mediante modelos inteligentes que optimizan recursos y mejoran la rentabilidad.",
    color: "from-yellow-400 to-orange-500",
  },
  {
    id: 4,
    icono: <FaBrain />,
    titulo: "Consultorías especializadas",
    descripcion:
      "Asesoría experta en sistemas eléctricos y mercado de energía mayorista y minorista, combinando conocimiento sectorial y tecnología.",
    color: "from-blue-500 to-indigo-600",
  },
  {
    id: 5,
    icono: <FaCogs />,
    titulo: "Automatización de procesos",
    descripcion:
      "Soluciones inteligentes que reducen costos, eliminan tareas repetitivas y aumentan la productividad operativa.",
    color: "from-green-500 to-emerald-600",
  },
  {
    id: 6,
    icono: <FaRobot />,
    titulo: "Inteligencia artificial aplicada",
    descripcion:
      "Implementación de algoritmos de IA que potencian el análisis predictivo y la optimización del negocio energético.",
    color: "from-red-500 to-rose-600",
  },
];

// ======= VENTAJAS =======
const ventajas = [
  {
    icono: <FaClock />,
    titulo: "Tiempo real",
    descripcion:
      "La información del mercado energético se procesa y actualiza de forma continua para decisiones inmediatas.",
  },
  {
    icono: <FaShieldAlt />,
    titulo: "Confiabilidad",
    descripcion:
      "Los modelos se construyen sobre fuentes verificadas y metodologías validadas por expertos del sector.",
  },
  {
    icono: <FaRocket />,
    titulo: "Agilidad operativa",
    descripcion:
      "Las plataformas permiten anticipar escenarios y actuar con rapidez frente a los cambios del mercado.",
  },
  {
    icono: <FaChartBar />,
    titulo: "Visión estratégica",
    descripcion:
      "El análisis avanzado convierte datos complejos en conocimiento accionable para la alta dirección.",
  },
];

// ======= ESTADÍSTICAS =======
const estadisticas = [
  { valor: "500+", label: "Variables analizadas", icono: <FaDatabase /> },
  { valor: "24/7", label: "Monitoreo continuo", icono: <FaClock /> },
  { valor: "95%", label: "Precisión predictiva", icono: <FaChartLine /> },
  { valor: "+15", label: "Años de experiencia", icono: <FaStar /> },
];

// ======= TESTIMONIOS =======
const testimonios = [
  {
    texto:
      "La plataforma permite anticipar escenarios del mercado con un nivel de precisión que transforma la planificación estratégica de las empresas energéticas.",
    autor: "Director de Planeación",
    empresa: "Sector eléctrico",
  },
  {
    texto:
      "Las proyecciones de precios y demanda se convirtieron en una herramienta indispensable para la toma de decisiones diaria en la operación del mercado.",
    autor: "Gerente de Comercialización",
    empresa: "Generadora de energía",
  },
  {
    texto:
      "La automatización de procesos liberó al equipo de tareas repetitivas y permitió enfocar el talento humano en análisis de alto valor.",
    autor: "CIO",
    empresa: "Empresa distribuidora",
  },
];

export default function NuestroPortafolioForm() {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [contadores, setContadores] = useState(estadisticas.map(() => 0));
  const videoRef = useRef(null);
  const statsRef = useRef(null);
  const navigate = useNavigate();

  // Animación de contadores al entrar en viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            estadisticas.forEach((stat, i) => {
              const match = stat.valor.match(/\d+/);
              if (match) {
                const target = parseInt(match[0]);
                let current = 0;
                const increment = target / 40;
                const timer = setInterval(() => {
                  current += increment;
                  if (current >= target) {
                    current = target;
                    clearInterval(timer);
                  }
                  setContadores((prev) => {
                    const newArr = [...prev];
                    newArr[i] = Math.floor(current);
                    return newArr;
                  });
                }, 30);
              }
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  const toggleVideo = () => {
    if (videoRef.current) {
      if (videoPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setVideoPlaying(!videoPlaying);
    }
  };

  const irARegistro = () => {
    navigate("/register");
  };

  const irAContacto = () => {
    navigate("/contactenos");
  };

  const formatValor = (original, contador) => {
    if (original.includes("+")) return `${contador}+`;
    if (original.includes("%")) return `${contador}%`;
    if (original.includes("/")) return original;
    return contador;
  };

  return (
    <div className="min-h-screen bg-[#1f1b24] text-white font-nexa font-normal flex flex-col">
      {/* ======= NAVBAR ======= */}
      <Navbar />

      {/* ======= HERO ======= */}
      <section className="relative w-full min-h-[70vh] overflow-hidden flex items-center">
        {/* Fondo animado con gradientes */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1f1b24] via-[#2a2533] to-[#1f1b24]"></div>
        <div className="absolute top-20 left-20 w-96 h-96 bg-[#00b3b3]/20 rounded-full blur-[120px] animate-pulse"></div>
        <div
          className="absolute bottom-20 right-20 w-96 h-96 bg-[#00e68a]/20 rounded-full blur-[120px] animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>

        {/* Grid pattern */}
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "linear-gradient(rgba(0,230,138,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,230,138,0.3) 1px, transparent 1px)",
            backgroundSize: "50px 50px",
          }}
        ></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16 w-full">
          <div className="inline-flex items-center gap-2 bg-[#00e68a]/20 border border-[#00e68a] text-[#00e68a] px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <FaBolt />
            <span>Portafolio QuarkIA</span>
          </div>

          <h1 className="font-elianto text-4xl md:text-6xl lg:text-7xl uppercase tracking-wider text-white leading-tight drop-shadow-[0_0_20px_rgba(0,230,138,0.5)] mb-6">
            Decisiones
            <br />
            <span className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] bg-clip-text text-transparent">
              inteligentes
            </span>
          </h1>

          <p className="text-lg md:text-2xl text-gray-200 max-w-3xl leading-relaxed mb-8">
            QuarkIA transforma el sector energético con soluciones basadas en
            datos en tiempo real, inteligencia artificial y analítica avanzada.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={irARegistro}
              className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#1f1b24] font-bold px-8 py-4 rounded-xl hover:scale-105 transition-transform flex items-center gap-2 shadow-xl"
            >
              Suscribirse ahora <FaArrowRight />
            </button>
            <button
              onClick={irAContacto}
              className="bg-[#2a2533] border border-[#00e68a]/30 text-white font-bold px-8 py-4 rounded-xl hover:border-[#00e68a] transition-all"
            >
              Solicitar demo
            </button>
          </div>
        </div>
      </section>

      {/* ======= SECCIÓN DE VIDEO ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 py-20">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#00b3b3]/20 border border-[#00b3b3] text-[#00b3b3] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <FaPlay className="text-xs" />
            <span>Video presentación</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            El mercado energético{" "}
            <span className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] bg-clip-text text-transparent">
              en movimiento
            </span>
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Un recorrido por el panorama actual del sector energético y la forma
            en que QuarkIA acompaña a las empresas en su transformación.
          </p>
        </div>

        {/* Video container */}
        <div className="relative group rounded-3xl overflow-hidden shadow-2xl border border-[#00e68a]/20 bg-[#2a2533]">
          <div className="relative aspect-video">
            <video
              ref={videoRef}
              className="w-full h-full object-cover"
              poster="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1600&h=900&fit=crop"
              onPlay={() => setVideoPlaying(true)}
              onPause={() => setVideoPlaying(false)}
              onEnded={() => setVideoPlaying(false)}
            >
              <source
                src="https://videos.pexels.com/video-files/3129957/3129957-uhd_3840_2160_25fps.mp4"
                type="video/mp4"
              />
              El navegador no soporta video HTML5.
            </video>

            {/* Overlay con botón play */}
            {!videoPlaying && (
              <div className="absolute inset-0 bg-gradient-to-t from-[#1f1b24]/90 via-[#1f1b24]/40 to-transparent flex items-center justify-center cursor-pointer"
                   onClick={toggleVideo}>
                <button
                  className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-r from-[#00b3b3] to-[#00e68a] flex items-center justify-center shadow-2xl hover:scale-110 transition-transform group-hover:scale-110"
                  aria-label="Reproducir video"
                >
                  <FaPlay className="text-[#1f1b24] text-3xl md:text-4xl ml-2" />
                </button>
              </div>
            )}

            {/* Controles cuando está reproduciendo */}
            {videoPlaying && (
              <button
                onClick={toggleVideo}
                className="absolute bottom-4 right-4 w-12 h-12 rounded-full bg-[#1f1b24]/80 backdrop-blur-sm hover:bg-[#00e68a] text-white hover:text-[#1f1b24] flex items-center justify-center transition-all"
                aria-label="Pausar video"
              >
                <FaPause />
              </button>
            )}

            {/* Badge inferior */}
            <div className="absolute bottom-4 left-4 bg-[#1f1b24]/80 backdrop-blur-sm px-4 py-2 rounded-full text-sm text-white flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#00e68a] animate-pulse"></span>
              Sector energético · 2026
            </div>
          </div>
        </div>
      </section>

      {/* ======= ESTADÍSTICAS ======= */}
      <section ref={statsRef} className="max-w-7xl mx-auto w-full px-6 md:px-12 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {estadisticas.map((stat, i) => (
            <div
              key={i}
              className="bg-gradient-to-br from-[#2a2533] to-[#1f1b24] border border-white/5 rounded-2xl p-6 text-center hover:border-[#00e68a]/40 hover:-translate-y-1 transition-all shadow-xl"
            >
              <div className="text-4xl text-[#00e68a] mb-3 flex justify-center">
                {stat.icono}
              </div>
              <p className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-[#00b3b3] to-[#00e68a] bg-clip-text text-transparent">
                {formatValor(stat.valor, contadores[i])}
              </p>
              <p className="text-sm text-gray-400 mt-2 uppercase tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ======= SERVICIOS ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 py-20">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#00e68a]/20 border border-[#00e68a] text-[#00e68a] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <FaCogs />
            <span>Servicios QuarkIA</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Un portafolio integral
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Cada servicio está diseñado para potenciar la transformación digital
            de las empresas del sector energético.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicios.map((s) => (
            <div
              key={s.id}
              className="group relative bg-[#2a2533] rounded-2xl p-8 border border-white/5 hover:border-[#00e68a]/40 hover:-translate-y-2 transition-all duration-300 overflow-hidden"
            >
              {/* Efecto de fondo al hover */}
              <div
                className={`absolute inset-0 bg-gradient-to-br ${s.color} opacity-0 group-hover:opacity-5 transition-opacity`}
              ></div>

              {/* Ícono */}
              <div
                className={`relative w-16 h-16 rounded-2xl bg-gradient-to-br ${s.color} flex items-center justify-center text-3xl text-[#1f1b24] mb-5 shadow-lg group-hover:scale-110 transition-transform`}
              >
                {s.icono}
              </div>

              <h3 className="relative text-xl font-bold text-white mb-3 group-hover:text-[#00e68a] transition-colors">
                {s.titulo}
              </h3>
              <p className="relative text-gray-300 text-sm leading-relaxed">
                {s.descripcion}
              </p>

              {/* Flecha esquina */}
              <div
                onClick={() => navigate("/servicios")}
                className="relative mt-5 flex items-center gap-2 text-[#00e68a] text-sm font-semibold opacity-0 group-hover:opacity-100 transition-all cursor-pointer"
              >
                <span>Conocer más</span>
                <FaArrowRight />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ======= VENTAJAS DE DECISIONES BASADAS EN DATOS ======= */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#1f1b24] via-[#2a2533] to-[#1f1b24]"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#00e68a]/5 rounded-full blur-[150px]"></div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Texto */}
            <div>
              <div className="inline-flex items-center gap-2 bg-[#00b3b3]/20 border border-[#00b3b3] text-[#00b3b3] px-4 py-2 rounded-full text-sm font-semibold mb-4">
                <FaBrain />
                <span>Inteligencia de datos</span>
              </div>
              <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
                Decisiones basadas en{" "}
                <span className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] bg-clip-text text-transparent">
                  datos en tiempo real
                </span>
              </h2>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                En un mercado donde cada minuto cuenta, QuarkIA pone al alcance
                de las empresas energéticas la capacidad de interpretar,
                anticipar y actuar con información confiable y actualizada.
              </p>

              <div className="space-y-4">
                {[
                  "Análisis predictivo del precio de bolsa",
                  "Monitoreo continuo de variables del sistema",
                  "Alertas tempranas sobre desviaciones operativas",
                  "Dashboards personalizados para cada rol del negocio",
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <FaCheckCircle className="text-[#00e68a] text-xl mt-0.5 flex-shrink-0" />
                    <span className="text-gray-200">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Ventajas grid */}
            <div className="grid grid-cols-2 gap-5">
              {ventajas.map((v, i) => (
                <div
                  key={i}
                  className="bg-[#2a2533] border border-white/5 rounded-2xl p-6 hover:border-[#00e68a]/40 hover:-translate-y-1 transition-all shadow-xl"
                  style={{ marginTop: i % 2 === 1 ? "2rem" : "0" }}
                >
                  <div className="text-3xl text-[#00e68a] mb-3">{v.icono}</div>
                  <h4 className="text-lg font-bold text-white mb-2">
                    {v.titulo}
                  </h4>
                  <p className="text-sm text-gray-400 leading-relaxed">
                    {v.descripcion}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ======= TESTIMONIOS ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 py-20">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#00e68a]/20 border border-[#00e68a] text-[#00e68a] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <FaQuoteLeft />
            <span>Voces del sector</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Lo que dicen los profesionales
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonios.map((t, i) => (
            <div
              key={i}
              className="bg-[#2a2533] rounded-2xl p-8 border border-white/5 hover:border-[#00e68a]/40 transition-all relative"
            >
              <FaQuoteLeft className="text-4xl text-[#00e68a]/30 mb-4" />
              <p className="text-gray-200 leading-relaxed mb-6 italic">
                "{t.texto}"
              </p>
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, idx) => (
                  <FaStar key={idx} className="text-yellow-400 text-sm" />
                ))}
              </div>
              <div className="border-t border-white/10 pt-4">
                <p className="font-bold text-white">{t.autor}</p>
                <p className="text-sm text-gray-400">{t.empresa}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ======= CTA FINAL ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 py-20">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#00b3b3] via-[#009999] to-[#00e68a] p-10 md:p-16 shadow-2xl">
          {/* Elementos decorativos */}
          <div className="absolute -top-20 -right-20 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage:
                "radial-gradient(circle, rgba(31,27,36,0.3) 1px, transparent 1px)",
              backgroundSize: "30px 30px",
            }}
          ></div>

          <div className="relative z-10 text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-[#1f1b24]/20 border border-[#1f1b24]/30 text-[#1f1b24] px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <FaRocket />
              <span>Comenzar ahora</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-extrabold text-[#1f1b24] mb-4 leading-tight">
              La transformación digital del sector energético comienza con una
              decisión
            </h2>
            <p className="text-[#1f1b24]/80 text-lg md:text-xl mb-8 max-w-2xl mx-auto">
              Las empresas que se suscriben a QuarkIA acceden a las herramientas,
              análisis y soporte que redefinen la forma de gestionar la energía.
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <button
                onClick={irARegistro}
                className="bg-[#1f1b24] text-white font-bold px-10 py-4 rounded-xl hover:scale-105 transition-transform flex items-center gap-2 shadow-xl text-lg"
              >
                Suscribirse ahora <FaArrowRight />
              </button>
              <button
                onClick={irAContacto}
                className="bg-white/20 backdrop-blur-sm border-2 border-[#1f1b24] text-[#1f1b24] font-bold px-10 py-4 rounded-xl hover:bg-[#1f1b24] hover:text-white transition-all text-lg"
              >
                Hablar con un asesor
              </button>
            </div>

            <p className="text-[#1f1b24]/70 text-sm mt-6">
              Sin compromiso · Soporte especializado · Resultados comprobados
            </p>
          </div>
        </div>
      </section>

      {/* ======= FOOTER ======= */}
      <footer className="bg-[#16131a] py-8 text-center border-t border-gray-700 mt-auto">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex space-x-6 text-2xl text-[#00b3b3]">
            <a
              href="https://wa.me/573001234567"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaFacebook />
            </a>
          </div>

          <div className="flex flex-col items-center text-sm md:text-base space-y-2">
            <p className="flex items-center space-x-2">
              <FaEnvelope className="text-[#00b3b3]" />
              <span>info@quarkia.com.co</span>
            </p>
            <p className="flex items-center space-x-2">
              <FaPhoneAlt className="text-[#00b3b3]" />
              <span>+57 311 383 6855</span>
            </p>
          </div>

          <p className="text-gray-400 text-xs mt-4">
            © {new Date().getFullYear()} QuarkIA S.A.S. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
